module.exports = __webpack_public_path__ + "static/images/styles/images/nations/ussr-cn.e8aed93b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/ussr-cn.png
// module id = 3677
// module chunks = 11